var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.72,
    height: 15.283,
    viewBox: "0 0 7.72 15.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook_1_",
    "data-name": "facebook (1)",
    d: "M126.929,8.14H128.6v6.9a.246.246,0,0,0,.246.246h2.84a.246.246,0,0,0,.247-.246V8.172h1.926a.247.247,0,0,0,.245-.218l.292-2.539a.246.246,0,0,0-.245-.275h-2.218V3.548c0-.48.258-.723.768-.723h1.45a.247.247,0,0,0,.247-.246V.248A.246.246,0,0,0,134.155,0h-2l-.092,0a3.83,3.83,0,0,0-2.5.944,2.626,2.626,0,0,0-.873,2.335V5.14h-1.759a.246.246,0,0,0-.246.246V7.893A.247.247,0,0,0,126.929,8.14Z",
    transform: "translate(-126.682)",
    fill: "#040505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1c58d560ae5a5ef9fb91f5c4ef86ee6c.svg";
export { ForwardRef as ReactComponent };